<form [formGroup]="searchCarForm">
    <div [ngClass]="{'search-wrapper': true, 'result': true}">
        <div class="search-container car-search-new-layout">
            <app-multi-booking-context
                *ngIf="this.searchService.multiTripBooking"
                [tripType]="this.searchService.tripType"
                [tripName]="this.searchService.tripName">
            </app-multi-booking-context>

            <!-- Row 1: Pickup and Dropoff Locations (Dynamic Layout) -->
            <div class="row location-row">
                <!-- Pickup Location - Takes full width when sameAddress is true -->
                <div [ngClass]="'col-xl-6 col-lg-6 col-md-6 col-sm-12'">
                    <div class="location-input-group" (click)="focusInput($event)">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin w-6 h-6 text-black opacity-40" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                        </div>
                        <div class="location-card-label">
                          <div class="location-card-label">

                              <span class="label-text">{{('search.PICKUP_LOCATION' | translate)}}</span>
                          </div>
                          <div class="location-input-content">
                              <div class="car-main-InputContainer">
                                  <div class="location-input-wrapper">
                                      <!-- Hidden field for the selected value -->
                                      <input type="hidden" formControlName="source" (ngModel)="pickUpModal" tabindex="-1" />

                                      <div id="inputFieldIDSourceAirport">
                                          <!-- Material Input Field -->
                                          <mat-form-field appearance="fill" class="custom-fill">
                                              <input matInput [placeholder]="'search.ENTER_AIRPORT_CITY_ADDRESS' | translate"
                                                  #sourceAutoTrigger="matAutocompleteTrigger"
                                                  class="location-input"
                                                  (focus)="onSourceFocus()" (keydown)="onKeyDown($event)"
                                                  (blur)="isFocused = false" [matAutocomplete]="autoSource"
                                                  [formControl]="searchCarForm.controls['sourceAirportCode']">

                                              <!-- Error Message -->
                                              <mat-error *ngIf="searchCarForm.controls['sourceAirportCode'].hasError('required') &&
                                                  (searchCarForm.controls['sourceAirportCode'].touched || searchCarForm.controls['sourceAirportCode'].dirty)">
                                                  {{ 'search.Pleaseenteravalidlocationorairport' | translate }}
                                              </mat-error>
                                          </mat-form-field>

                                          <!-- Material Autocomplete -->
                                          <mat-autocomplete class="airport-autocomplete" #autoSource="matAutocomplete"
                                              [autoActiveFirstOption]="false" [disableRipple]="true"
                                              (optionSelected)="onAutoCompleteSelect($event, 'source', 'inputFieldIDSourceAirport')"
                                              (closed)="onAutoCompleteClose($event, 'source', 'inputFieldIDSourceAirport')">
                                              <mat-option *ngFor="let item of autoCompleteSourceItems" [value]="getSetSourceFormValue(item)">
                                                  <ng-container *ngIf="item.type === 'AIRPORT'">
                                                      <svg  class="airport-icon plane-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.46 3.98C8.19 3.72 7.8 3.63 7.44 3.73C6.76 3.92 6.44 4.7 6.79 5.31L10.23 11.27L5.26 12.6L3.69 11.36C3.44 11.17 3.12 11.1 2.81 11.18L2.48 11.27C2.16 11.35 2.01 11.72 2.18 12L4.06 15.25C4.29 15.64 4.75 15.83 5.18 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z" fill="currentColor"/>
            </svg>
                                                      <span class="option-content">
                                                          <span class="option-main-text">{{ item.code }}</span>
                                                          <span class="option-sub-text" *ngIf="item.name">{{ item.name }}</span>
                                                      </span>
                                                  </ng-container>
                                                  <ng-container *ngIf="item.type === 'ADDRESS'">
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="airport-icon map-pin-icon">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
                                                      <span class="option-content">
                                                          <span class="option-main-text">{{ item.label }}</span>
                                                      </span>
                                                  </ng-container>
                                              </mat-option>
                                          </mat-autocomplete>
                                      </div>

                                      <!-- Hidden Field for Source Airport Code -->
                                      <input type="hidden" formControlName="sourceAirportCode" tabindex="-1" />
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>

                <!-- Dropoff Location - Hidden when sameAddress is true -->
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="location-input-group" (click)="focusInput($event)">
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin w-6 h-6 text-black opacity-40" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                      </div>
                      <div class="location-input-wrapper">
                        <div class="location-card-label">
                            <span class="label-text">{{ 'search.dropoffLocation' | translate }}</span>
                        </div>
                        <div class="location-input-content">
                            <div class="car-main-InputContainer">
                                <div class="location-input-wrapper">
                                    <input type="hidden" formControlName="destination" (ngModel)="dropOffModal" tabindex="-1" />

                                    <div id="inputFieldIDDestAirport">
                                        <!-- Material Input Field -->
                                        <mat-form-field appearance="fill" class="custom-fill">
                                            <input matInput
                                                #destAutoTrigger="matAutocompleteTrigger"
                                                [placeholder]="'search.ENTER_AIRPORT_CITY_ADDRESS' | translate"
                                                class="location-input"
                                                (focus)="onDestinationFocus()"
                                                (keydown)="onKeyDown($event)"
                                                (blur)="onDestinationBlur()"
                                                [matAutocomplete]="autoDest"
                                                [formControl]="searchCarForm.controls['destinationAirportCode']">

                                            <!-- Error Message -->
                                            <mat-error *ngIf="searchCarForm.controls['destinationAirportCode'].hasError('required') &&
                                                (searchCarForm.controls['destinationAirportCode'].touched || searchCarForm.controls['destinationAirportCode'].dirty)">
                                                {{ 'search.Pleaseenteravalidlocationorairport' | translate }}
                                            </mat-error>
                                        </mat-form-field>

                                        <!-- Material Autocomplete -->
                                        <mat-autocomplete class="airport-autocomplete" #autoDest="matAutocomplete"
                                            [autoActiveFirstOption]="false" [disableRipple]="true"
                                            (optionSelected)="onAutoCompleteSelect($event, 'destination', 'inputFieldIDDestAirport')"
                                            (closed)="onAutoCompleteClose($event, 'destination', 'inputFieldIDDestAirport')">
                                            <mat-option *ngFor="let item of autoCompleteDestItems" [value]="getSetSourceFormValue(item)">
                                                <ng-container *ngIf="item.type === 'AIRPORT'">
                                                    <i class="fa fa-plane" aria-hidden="true"></i>
                                                    <span class="option-content">
                                                        <span class="option-main-text">{{ item.code }}</span>
                                                        <span class="option-sub-text" *ngIf="item.name">{{ item.name }}</span>
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf="item.type === 'ADDRESS'">
                                                    <i class="fa fa-location-arrow" aria-hidden="true"></i>
                                                    <span class="option-content">
                                                        <span class="option-main-text">{{ item.label }}</span>
                                                    </span>
                                                </ng-container>
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>

                                    <!-- Hidden Field for Destination Airport Code -->
                                    <input type="hidden" formControlName="destinationAirportCode" tabindex="-1" />
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>

            <!-- Checkbox Row: "Add a different drop-off location" -->
            <div [hidden]="true" class="row checkbox-row">
                <div class="col-12">
                    <div class="checkbox-wrapper">
                        <span (click)="boxChecked()" style="cursor:pointer !important;">
                            <input type="checkbox" class="" style="display:none;" [attr.disabled]="true">
                            <span class="{{searchCarForm.controls['sameAddress'].value ? 'checkbox12':'checkbox13'}}"></span>
                            <label class="checkboxLabel1">{{'search.Addadifferentdrop-offlocation' | translate }}</label>
                        </span>
                    </div>
                </div>
            </div>

            <!-- Row 2: Pickup and Dropoff Date & Time -->
            <div class="row datetime-row">
                <!-- Pickup Date & Time -->
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="datetime-input-group">
                        <div class="datetime-card" (click)="toggleCarPickupCalendar(); pickupDateInput.focus()">
                          <div>
                             <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26">
<path d="M0 0 C8.58 0 17.16 0 26 0 C26.020625 2.43375 26.04125 4.8675 26.0625 7.375 C26.071604 8.13989746 26.08070801 8.90479492 26.09008789 9.69287109 C26.11111111 14.77777778 26.11111111 14.77777778 25 17 C21.02084841 17.02886984 17.04172347 17.04675406 13.0625 17.0625 C11.35803711 17.07506836 11.35803711 17.07506836 9.61914062 17.08789062 C8.53955078 17.09111328 7.45996094 17.09433594 6.34765625 17.09765625 C4.84730835 17.10551147 4.84730835 17.10551147 3.31665039 17.11352539 C1 17 1 17 0 16 C-0.07325436 13.3013095 -0.09222351 10.63497444 -0.0625 7.9375 C-0.041875 5.318125 -0.02125 2.69875 0 0 Z M5 3 C5 3.99 5 4.98 5 6 C5.99 6 6.98 6 8 6 C8 5.01 8 4.02 8 3 C7.01 3 6.02 3 5 3 Z M11 3 C11 3.99 11 4.98 11 6 C11.99 6 12.98 6 14 6 C14 5.01 14 4.02 14 3 C13.01 3 12.02 3 11 3 Z M18 3 C18 3.99 18 4.98 18 6 C18.66 6 19.32 6 20 6 C20 5.01 20 4.02 20 3 C19.34 3 18.68 3 18 3 Z M5 10 C5.33 10.99 5.66 11.98 6 13 C6.66 13 7.32 13 8 13 C8 12.01 8 11.02 8 10 C7.01 10 6.02 10 5 10 Z M11 10 C11 10.99 11 11.98 11 13 C11.99 13 12.98 13 14 13 C14 12.01 14 11.02 14 10 C13.01 10 12.02 10 11 10 Z M18 10 C18 10.99 18 11.98 18 13 C18.66 13 19.32 13 20 13 C20 12.01 20 11.02 20 10 C19.34 10 18.68 10 18 10 Z " fill="#e3e5e5" transform="translate(0,8)"/>
<path d="M0 0 C3.97915159 -0.02886984 7.95827653 -0.04675406 11.9375 -0.0625 C13.07380859 -0.07087891 14.21011719 -0.07925781 15.38085938 -0.08789062 C16.46044922 -0.09111328 17.54003906 -0.09433594 18.65234375 -0.09765625 C20.15269165 -0.10551147 20.15269165 -0.10551147 21.68334961 -0.11352539 C24 0 24 0 25 1 C25 2.65 25 4.3 25 6 C16.42 6 7.84 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z M4 1 C5 3 5 3 5 3 Z " fill="#e3e5e5" transform="translate(1,1)"/>
</svg>
                          </div>
                          <div>
                            <div class="datetime-card-label">
                                <span class="label-text">{{'search.Pickup' | translate }}</span>
                            </div>
                            <div class="datetime-display">
                                <div class="date-section">

                                    <input #pickupDateInput type="text"
                                      class="date-text date-keyboard-input"
                                      [ngClass]="{'has-value': pickUpDate}"
                                      appSearchDateKeyboard
                                      [dateValue]="pickUpDate"
                                      [placeholder]="'search.DD_MMM_YYYY' | translate"
                                      [minDate]="minimumDate"
                                      [maxDate]="maximumDate"
                                      (dateCommitted)="setLeg1Date($event)"
                                      (dateTypingStarted)="closeCarPickupCalendar()"
                                      (calendarRequested)="showCarPickupCalendar || toggleCarPickupCalendar()"
                                      [attr.readonly]="isTabletOrMobile ? '' : null"
                                      autocomplete="off"
                                    />
                                </div>

                            </div>
                          </div>
                          <div class="time-section">
                                    <span class="material-icons time-icon">schedule</span>
                                    <span class="time-text">{{searchCarForm.controls['pickTime'].value}}</span>
                            </div>


                            <input bsDatepicker #pickUpDatePicker="bsDatepicker"
                                style="display: none;" formControlName="pickUpDate"
                                [minDate]="minimumDate" [maxDate]="maximumDate"
                                [bsConfig]="{showWeekNumbers: false}"
                                (bsValueChange)="setLeg1Date($event)" readonly />
                        </div>

                        <!-- Custom Calendar Popup for Pickup -->
                        <div *ngIf="showCarPickupCalendar"
                            class="car-calendar-container car-pickup-calendar"
                            [ngClass]="{'mobile-fullscreen': isTabletOrMobile}">

                            <!-- Mobile Header -->
                            <div *ngIf="isTabletOrMobile" class="car-calendar-header">
                                <button type="button" class="header-close-btn" (click)="closeCarPickupCalendar()">
                                    <span class="material-icons">close</span>
                                </button>
                                <div class="header-title">{{ 'search.Pick-upDate' | translate }} & Time</div>
                            </div>

                            <!-- Time Dropdown -->
                            <div class="car-time-dropdown">
                              <div class="car-time-dropdown-wrapper">
                                <div class="time-label">Time</div>
                                <div class="time-select" (click)="toggleCarPickupTimeDropdown()">
                                    <span>{{searchCarForm.controls['pickTime'].value}}</span>
                                    <span class="material-icons">{{showCarPickupTimeDropdown ? 'expand_less' : 'expand_more'}}</span>
                                </div>
                              </div>

                                <!-- Time Options Grid -->
                                <div *ngIf="showCarPickupTimeDropdown" class="time-options-grid">
                                    <div *ngFor="let time of carTimeOptions"
                                        class="time-option-item"
                                        [ngClass]="{'selected': searchCarForm.controls['pickTime'].value === time}"
                                        (click)="selectCarPickupTime(time)">
                                        {{formatTimeDisplay(time)}}
                                    </div>
                                </div>
                            </div>

                            <!-- Calendar Display -->
                            <div class="calendar-display">
                                <bs-datepicker-inline
                                    [bsValue]="getPickUpDate"
                                    [bsConfig]="{showWeekNumbers: false}"
                                    [minDate]="minimumDate"
                                    [maxDate]="maximumDate"
                                    (bsValueChange)="setCarPickupDate($event)">
                                </bs-datepicker-inline>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Dropoff Date & Time -->
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="datetime-input-group">
                        <div class="datetime-card" (click)="toggleCarDropoffCalendar(); dropoffDateInput.focus()">
                          <div>
                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26">
<path d="M0 0 C8.58 0 17.16 0 26 0 C26.020625 2.43375 26.04125 4.8675 26.0625 7.375 C26.071604 8.13989746 26.08070801 8.90479492 26.09008789 9.69287109 C26.11111111 14.77777778 26.11111111 14.77777778 25 17 C21.02084841 17.02886984 17.04172347 17.04675406 13.0625 17.0625 C11.35803711 17.07506836 11.35803711 17.07506836 9.61914062 17.08789062 C8.53955078 17.09111328 7.45996094 17.09433594 6.34765625 17.09765625 C4.84730835 17.10551147 4.84730835 17.10551147 3.31665039 17.11352539 C1 17 1 17 0 16 C-0.07325436 13.3013095 -0.09222351 10.63497444 -0.0625 7.9375 C-0.041875 5.318125 -0.02125 2.69875 0 0 Z M5 3 C5 3.99 5 4.98 5 6 C5.99 6 6.98 6 8 6 C8 5.01 8 4.02 8 3 C7.01 3 6.02 3 5 3 Z M11 3 C11 3.99 11 4.98 11 6 C11.99 6 12.98 6 14 6 C14 5.01 14 4.02 14 3 C13.01 3 12.02 3 11 3 Z M18 3 C18 3.99 18 4.98 18 6 C18.66 6 19.32 6 20 6 C20 5.01 20 4.02 20 3 C19.34 3 18.68 3 18 3 Z M5 10 C5.33 10.99 5.66 11.98 6 13 C6.66 13 7.32 13 8 13 C8 12.01 8 11.02 8 10 C7.01 10 6.02 10 5 10 Z M11 10 C11 10.99 11 11.98 11 13 C11.99 13 12.98 13 14 13 C14 12.01 14 11.02 14 10 C13.01 10 12.02 10 11 10 Z M18 10 C18 10.99 18 11.98 18 13 C18.66 13 19.32 13 20 13 C20 12.01 20 11.02 20 10 C19.34 10 18.68 10 18 10 Z " fill="#e3e5e5" transform="translate(0,8)"/>
<path d="M0 0 C3.97915159 -0.02886984 7.95827653 -0.04675406 11.9375 -0.0625 C13.07380859 -0.07087891 14.21011719 -0.07925781 15.38085938 -0.08789062 C16.46044922 -0.09111328 17.54003906 -0.09433594 18.65234375 -0.09765625 C20.15269165 -0.10551147 20.15269165 -0.10551147 21.68334961 -0.11352539 C24 0 24 0 25 1 C25 2.65 25 4.3 25 6 C16.42 6 7.84 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z M4 1 C5 3 5 3 5 3 Z " fill="#e3e5e5" transform="translate(1,1)"/>
</svg>
                          </div>
                          <div>
                            <div class="datetime-card-label">
                                <span class="label-text">{{ 'search.Drop-off' | translate }}</span>
                            </div>
                            <div class="datetime-display">
                                <div class="date-section">

                                    <input #dropoffDateInput type="text"
                                      class="date-text date-keyboard-input"
                                      [ngClass]="{'has-value': dropOffDate}"
                                      appSearchDateKeyboard
                                      [dateValue]="dropOffDate"
                                      [placeholder]="'search.DD_MMM_YYYY' | translate"
                                      [minDate]="minimumDate3"
                                      [maxDate]="maximumDate"
                                      (dateCommitted)="setLeg2Date($event)"
                                      (dateTypingStarted)="closeCarDropoffCalendar()"
                                      (calendarRequested)="showCarDropoffCalendar || toggleCarDropoffCalendar()"
                                      [attr.readonly]="isTabletOrMobile ? '' : null"
                                      autocomplete="off"
                                    />
                                </div>
                            </div>
                          </div>
                          <div class="time-section">
                                    <span class="material-icons time-icon">schedule</span>
                                    <span class="time-text">{{searchCarForm.controls['dropTime'].value}}</span>
                                </div>

                            <input bsDatepicker #dropOffDatePicker="bsDatepicker"
                                style="display: none;" formControlName="dropOffDate"
                                [minDate]="minimumDate3" [maxDate]="maximumDate"
                                [bsConfig]="{showWeekNumbers: false}"
                                (bsValueChange)="setLeg2Date($event)" readonly />
                        </div>

                        <!-- Custom Calendar Popup for Dropoff -->
                        <div *ngIf="showCarDropoffCalendar"
                            class="car-calendar-container car-dropoff-calendar"
                            [ngClass]="{'mobile-fullscreen': isTabletOrMobile}">

                            <!-- Mobile Header -->
                            <div *ngIf="isTabletOrMobile" class="car-calendar-header">
                                <button type="button" class="header-close-btn" (click)="closeCarDropoffCalendar()">
                                    <span class="material-icons">close</span>
                                </button>
                                <div class="header-title">{{ 'search.Drop-off' | translate }} Date & Time</div>
                            </div>

                            <!-- Time Dropdown -->
                            <div class="car-time-dropdown">
                              <div class="car-time-dropdown-wrapper">
                                <div class="time-label">Time</div>
                                <div class="time-select" (click)="toggleCarDropoffTimeDropdown()">
                                    <span>{{searchCarForm.controls['dropTime'].value}}</span>
                                    <span class="material-icons">{{showCarDropoffTimeDropdown ? 'expand_less' : 'expand_more'}}</span>
                                </div>
                              </div>

                                <!-- Time Options Grid -->
                                <div *ngIf="showCarDropoffTimeDropdown" class="time-options-grid">
                                    <div *ngFor="let time of carTimeOptions"
                                        class="time-option-item"
                                        [ngClass]="{'selected': searchCarForm.controls['dropTime'].value === time}"
                                        (click)="selectCarDropoffTime(time)">
                                        {{formatTimeDisplay(time)}}
                                    </div>
                                </div>
                            </div>

                            <!-- Calendar Display -->
                            <div class="calendar-display">
                                <bs-datepicker-inline
                                    [bsValue]="getDropOffDate"
                                    [bsConfig]="{showWeekNumbers: false}"
                                    [minDate]="minimumDate3"
                                    [maxDate]="maximumDate"
                                    (bsValueChange)="setCarDropoffDate($event)">
                                </bs-datepicker-inline>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Row 3: Select Traveler -->
            <div class="row traveler-row">
                <div class="col-12 col-lg-6">
                    <div class="select-traveler-card-wrapper">
                        <div class="select-traveler-card" (click)="openTravelerModal(); $event.stopPropagation()">
                            <div class="traveler-icon-label">
                                <span class="material-icons traveler-icon">person</span>
                                <span class="traveler-label">{{getTravelerCountText()}}</span>
                            </div>
                            <div class="add-traveler-icon" *ngIf="this.userAccountInfoService.showRadio">
                                <span class="material-icons">person_add</span>
                            </div>
                        </div>
                        <ng-container>
                            <app-employee-dropdown *ngIf="this.searchService.showTravelerDropDown" [viewMode]="'tab3'"></app-employee-dropdown>
                        </ng-container>

                    </div>
                </div>
            </div>

            <!-- Row 4: Search Button -->
            <div class="row search-button-row">
                <div class="col-12">
                    <div class="search-button-wrapper">
                        <button type="button"  class="btn primary-button  search-btn" (click)="submitForm()"
                            [disabled]="formIfInvalid">
                            {{'search.searchCar' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Error Message for Time Difference -->
            <div class="row" *ngIf="timeDifference">
                <div class="col-12">
                    <div class="error-message">
                        <span class="text-danger">{{'search.Thedrop-offmustoccuratleastonehourafterthepick-up' | translate }}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</form>
